import React, { JSX } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PrivateRoute } from './private-route';
import { PublicRoute } from './public-route';
import { ACCESS_TOKEN } from 'shared/constant';

interface AppRouteProps {
  routes: Array<{
    path: string;
    private: boolean;
    element: JSX.Element;
    open?: boolean;
  }>;
}

export default function AppRoute(props: AppRouteProps) {
  const token = localStorage.getItem(ACCESS_TOKEN) ?? '';

  return (
    <Routes>
      {props.routes.map((route) => (
        <Route
          path={route.path}
          key={route.path}
          element={
            route.private ? (
              <PrivateRoute>{route.element}</PrivateRoute>
            ) : (
              <PublicRoute authed={!!token} route={route}>
                {route.element}
              </PublicRoute>
            )
          }
        />
      ))}
    </Routes>
  );
}
